export const REASON_MAX_LENGTH = 255;
